import script from "./RateFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RateFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./RateFormModal.vue?vue&type=style&index=0&id=ba9ae034&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba9ae034"]])

export default __exports__